import log from 'salvo-lite/log'

class Required {
    constructor (elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._settings = JSON.parse(elem.dataset.validationRequired)
        this._elems = {
            'input': elem.querySelector(this._settings.elem)
        }
        this._messages = {
            'errors': elem.querySelectorAll('[data-validation-message="error"]')
        }
    }

    onInit () {
        this._attachDefaultEvents()
    }

    _attachDefaultEvents () {
        this._elems.input.addEventListener('click', e => {
            if (this._elems.input.checked) this._disableMessages()
        })
    }

    _disableMessages () {
        for (let messageElem of this._messages.errors) {
            messageElem.classList.add('hidden')
        }
    }
}

class Validation {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elems = {
            'container': elem,
            'required': elem.querySelectorAll('[data-validation-required]'),
            'checks': elem.querySelectorAll('[data-validation-check]')
        }
        this._validation = {
            'required': []
        }
        this._settings = {
        }
        this._settings = elem.dataset.validation.length > 0 ? Object.assign(this._settings, JSON.parse(elem.dataset.validation)) : this._settings
        this._theme = theme
    }

    onInit () {
        log.debug(this._name, 'Initiated', this)
        if (this._elems.required.length > 0) this._requiredLogic()
        this._applyDefaultEvents()
    }

    _applyDefaultEvents () {
        for (let checkElem of this._elems.checks) {
            checkElem.addEventListener('click', e => {
                if (this._runValidation()) {
                    this._postLogic(JSON.parse(checkElem.dataset.validationPassed))
                    return true
                }
                this._failLogic()
            })
        }
    }

    _failLogic () {
        for (let validationElem of this._validation.required) {
            if (!validationElem._elems.input.checked) {
                this._displayMessages(validationElem._messages.errors)
            }
        }
    }

    _displayMessages (elems) {
        for (let elem of elems) {
            elem.classList.remove('hidden')
        }
    }

    _postLogic (data) {
        if (data.elem) {
            let elem = this._elems.container.querySelector(data.elem)
            elem.click()
        }
        if (data.hideElems) this._changeElems(data.hideElems, 'add', 'visually-hidden')
        if (data.showElems) this._changeElems(data.showElems, 'remove', 'visually-hidden')
    }

    _changeElems (dataAttribute, method, className) {
        log.debug(this._name, 'CHANGED ELEMS NOW')
        let elems = document.querySelectorAll(dataAttribute)
        for (let elem of elems) elem.classList[method](className)
    }

    _requiredLogic () {
        for (let requiredElem of this._elems.required) {
            let reqElem = new Required(requiredElem)
            reqElem.onInit()
            this._validation.required.push(reqElem)
        }
    }

    _runValidation () {
        for (let validationElem of this._validation.required) {
            if (!validationElem._elems.input.checked) return false
        }
        return true
    }
}

export default Validation



// WEBPACK FOOTER //
// ./src/scripts/components/Validation.js